import { Flex } from '@pega/cosmos-react-core';
import React, { useCallback, useEffect, useState } from 'react';
import MessageList from '../../../cosmos-social/MessageList';

export interface DisplayChatProps {
  messages: any;
}

const gridStyle = {
  padding: '0rem 0.4rem 0.7rem 0.4rem',
  border: '0.06rem solid #D8D8D8',
  height: '75vh',
};

const DisplayChat: React.FC<DisplayChatProps> = ({ messages }) => {
  const [updatedMessageList, setUpdatedMessageList] = useState<any[]>([]);

  const formatMessages = useCallback(() => {
    const updatedMessages: any[] = [];
    messages?.forEach((item: any, index: any) => {
      const role = item.role;
      if (role !== 'system') {
        const message = {
          id: index,
          type: 'message',
          variant: ['assistant', 'bot'].includes(role) ? 'sender' : 'receiver',
          direction: ['assistant', 'bot'].includes(role) ? 'out' : 'in',
          message: item.content,
        };
        updatedMessages.push(message);
      }
    });
    setUpdatedMessageList(updatedMessages);
  }, [messages]);

  useEffect(() => {
    formatMessages();
  }, [formatMessages]);

  return (
    <Flex container style={gridStyle}>
      <MessageList tabIndex={0} messages={updatedMessageList} />
    </Flex>
  );
};

export default DisplayChat;
